import { capitalizeFirstLetter } from "../Constant/Utility";
import { getState } from "../Constant/LocalStorage";
import { CHOICE_DATA } from "../Pages/GetStarted/constants";

export const brandForm = (data) => {
  return {
    logo: data?.logo || "default",
    favicon: data?.favicon || "default",
    bannerText: data?.bannerText || "👋 Hey! How can we help you?",
    brandColor: data?.brandColor || "#878EFF",
    bannerTextColor: data?.bannerTextColor || "#FFFFFF",
    bannerImage: data?.bannerImage || "",
    navigationButtonText: data?.navigationButtonText || "",
    navigationButtonUrl: data?.navigationButtonUrl || "",
    errorPageText: data?.errorPageText || "This page does not exist",
    kbType: data?.kbType || CHOICE_DATA[1].ID
  };
};

export const userForm = (data) => {
  if (data) {
    return {
      avatarUrl: data?.avatarUrl,
      email: data?.email,
      firstName: capitalizeFirstLetter(data?.firstName),
      knowledgeBaseAssigned: data?.knowledgeBaseAssigned,
      lastName: data?.lastName,
      role: data?.role,
      userId: data?.userId,
      userName: data?.userName,
    };
  }
};

export const userListForm = (data) => {
  if (data) {
    return data?.map((item) => {
      return userForm(item);
    });
  }
};

export const sitePageForm = (data) => {
  if (data) {
    return {
      title:
        data.title ||
        getState("adminDetails")?.usergroupNameSlug + " " + "knowledge base",
      subdomain: data?.subdomain || getState("adminDetails")?.usergroupNameSlug,
      enableHelpForm: data?.enableHelpForm ? true : false,
      adminEmail: data?.adminEmail,
      helpPageName: data?.helpPageName || "Submit an Issue",
      helpPageHeading:
        data?.helpPageHeading ||
        "Couldn’t find what you are looking for? Submit an issue & we will get back to you.",
      helpPageMessage:
        data?.helpPageMessage ||
        "Your issue has been submitted. We will get back to you.",
      description: data?.description || "Our knowledge base has answers for common questions and doubts you may have"
    };
  }
};

export const snippetObj = (data) => {
  if (data) {
    return {
      name: data?.name,
      code: data?.code,
      codeSnippetId: data?.codeSnippetId,
    };
  }
};

export const codeSnippetForm = (data) => {
  if (data) {
    return data?.map((item) => {
      return snippetObj(item);
    });
  }
};
